import { Injectable } from "@angular/core";
import { Selector, State } from "@ngxs/store";
import { INgxsFormState } from "src/app/model/INgxsFormState";

export class CompanyRegisterFormStateModel {
    public form: INgxsFormState;
}

@State<CompanyRegisterFormStateModel>({
    name: "companyRegisterForm",
    defaults: {
        form: {
            model: null,
            dirty: false,
            status: "",
            errors: null,
        },
    },
})
@Injectable()
export class CompanyRegisterFormState {
    @Selector()
    static form(state: CompanyRegisterFormStateModel) {
        return state.form;
    }
}
